<forge-card class="chart" no-padding>
  <forge-toolbar>
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">Outstanding Invoices by Fund</h2>

      <div class="forge-typography--subheading1" fxLayout="row" fxLayoutAlign="space-between center">
        <span>As of {{AsOfDate | date: 'M/d/yyyy'}}</span>
        @if (isLoaded && chartHasData) {
          <span>
            <span class="forge-typography--heading2">Balance:</span> {{Balance | currency}}
          </span>
        }
      </div>
    </div>

    <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
      telemetry="Chart settings" aria-label="chart settings">
      <forge-tooltip>Chart settings</forge-tooltip>
      <forge-icon name="settings"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div class="metadata-padding">
    @if (isLoaded) {
      <div>
        @if (showChart) {
          <chartjs-container [config]="chartConfig">
          </chartjs-container>
        }
        <div [fxShow]="!chartHasData">Not enough data to display graph</div>
      </div>
    }

    @if (!isLoaded) {
      <busy-indicator [chart]="true"></busy-indicator>
    }
  </div>
</forge-card>
